import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      isDark: 'appConfig/isDark',
      isRTL: 'appConfig/isRTL',
    }),
  },
}
